import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {ToggleSwitchComponent} from "../../../basic-ui-components/form/toggle-switch/toggle-switch.component";
import {ModifyBiometricDialogBox} from "./boxes/modify-biometric-dialog.box";
import {ModifyBiometricSectionBox} from "./boxes/modify-biometric-info-section/modify-biometric-info-section.box";
import {ModifyBiometricToogleSectionBox} from "./boxes/modify-biometric-toggle-section/modify-biometric-toggle-section.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {CyClass} from "../../../../common/cy-classes";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";

export interface IModifyBiometricDialogOptions {
    dialogHandler: IModalDialogHandler;
}
export const ModifyBiometricDialogComponent: React.FC<IModifyBiometricDialogOptions> = observer((props) => {
    const services = useServices();
    const [isFeatureOn, setIsFeatureOn] = useState(false);

    useEffect(() => {
        const _updateTouchEnable = async () => {
            try {
                const isEnabled = await services.hybrid.isDeviceTouchEnable();

                if (isEnabled) {
                    const isFeatureOn = await services.hybrid.getTouchIDFeaturer().getTokenAndCheckEnable();
                    setIsFeatureOn(isFeatureOn);
                }
            } catch (err) {
                services.logger.error('Failed to modify touch ID feature', err);
            }
        }
        _updateTouchEnable();
    }, [services.analytics, services.hybrid, services.logger]);

    const _buttonCallBack = async (selectToggle: boolean) => {
        let strToggle = 'Menu toggle on';
        try {
            if (selectToggle) {
                await services.hybrid.isDeviceTouchEnable();
                const isDeviceTouchEnabled = services.hybrid.getTouchIDFeaturer().getModel().isDeviceTouchEnable();
                if (isDeviceTouchEnabled) {
                    await services.hybrid.getTouchIDFeaturer().getTokenFromSrv();
                    setIsFeatureOn(selectToggle)
                }
                else {
                    const isOpenSettingSupported = await services.hybrid.isOpenSettingSupported();
                    if (isOpenSettingSupported) {
                        await services.hybrid.openTouchIdSettings();
                    }
                    else {
                        services.logger.warning('The OS settings cannot be opened.');
                        props.dialogHandler.close();
                    }
                }

            } else {
                setIsFeatureOn(false);
                services.hybrid.clearToken();
                strToggle = 'Menu toggle off';
            }
        } catch (err) {
            services.logger.error('Failed to modify touch ID feature', err);
            props.dialogHandler.close();
        }

        services.analytics.sendOrbitUserFlowEvent ('Client_TouchID', strToggle);
    }

    return (
        <ModifyBiometricDialogBox>
            <ModifyBiometricSectionBox>
                {services.translation.translate('TOUCH_ID_CAPTION')}
            </ModifyBiometricSectionBox>
            <ModifyBiometricToogleSectionBox>
                <div>{services.translation.translate('TOUCH_ID_AUTO_SCREEN')}</div>
                <ToggleSwitchComponent checked={isFeatureOn} onToggle={(e) => _buttonCallBack(e)} className={CyClass('cy-biometric-login-toggle')} />
            </ModifyBiometricToogleSectionBox>
        </ModifyBiometricDialogBox>
    );
});